// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.SideBar {
  grid-area: sidebar;
  background-color: #ffffff;
  padding: 20px 16px;
  border-radius: 8px;
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.05);
  max-width: 280px;
  font-family: 'Segoe UI', Tahoma, Geneva, Verdana, sans-serif;
  display: flex;
  flex-direction: column;
  height: 100%;
  overflow-y: auto;
}

.sidebar-inner {
  display: flex;
  flex-direction: column;
  gap: 24px;
}

.sidebar-section {
  display: flex;
  flex-direction: column;
  gap: 12px;
}

.sidebar-title {
  font-size: 14px;
  font-weight: 600;
  color: #333;
  text-transform: uppercase;
  letter-spacing: 0.5px;
  margin-bottom: 6px;
  border-bottom: 1px solid #eee;
  padding-bottom: 4px;
}

.sidebar-actions {
  display: flex;
  flex-direction: column;
  gap: 10px;
}

/* Optional: shared button styles */
.btnf {
  padding: 10px 16px;
  border: none;
  border-radius: 6px;
  font-size: 14px;
  cursor: pointer;
  transition: background-color 0.3s ease;
  width: 100%;
  max-width: 220px;
  margin: 0 auto;
}

.btnf.include {
  background-color: #81c784; /* Soft green */
  color: #fff;
  border: none;
}

.btnf.include:hover {
  background-color: #66bb6a; /* Calm hover */
}

.btnf.exclude {
  background-color: #ef9a9a; /* Soft red */
  color: #fff;
  border: none;
}

.btnf.exclude:hover {
  background-color: #e57373; /* Calm hover */
}



.icon-wrapper {
  display: flex;
  align-items: center;
  justify-content: center;
  background-color: #f0f2f5;
  border-radius: 50%;
  width: 50px;
  height: 50px;
  transition: background-color 0.3s, transform 0.3s;
  position: relative;
  cursor: pointer;
}

.icon-wrapper:hover {
  background-color: #e0e7ff;
  transform: scale(1.1);
}

.Icon-clear {
  font-size: 30px;
  color: #007BFF;
  transition: color 0.2s;
}


.icon-wrapper:hover .con-clear {
  color: #0056b3;
}

/* Tooltip style */
.icon-wrapper::after {
  content: attr(data-tooltip);
  position: absolute;
  bottom: -30px;
  background-color: #333;
  color: #fff;
  font-size: 12px;
  padding: 4px 8px;
  border-radius: 4px;
  white-space: nowrap;
  opacity: 0;
  transform: translateY(10px);
  pointer-events: none;
  transition: opacity 0.3s, transform 0.3s;
}

.icon-wrapper:hover::after {
  opacity: 1;
  transform: translateY(0);
}

.p-style {
  display: flex;
  
  margin: 0; /* Adjust or remove this as necessary for your design */
  margin-top : 2%;
}

/* === Modal Overlay === */
.modalbox-overlay {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background: rgba(0, 0, 0, 0.5); 
  display: flex;
  justify-content: center;
  align-items: center;
  z-index: 1000;
}

/* === Modal Content === */
.modalbox-content {
  background: #ffffff;
  padding: 20px;
  border-radius: 12px;
  box-shadow: 0px 4px 15px rgba(0, 0, 0, 0.3);
  width: 350px;
  max-width: 90%;
  text-align: center;
  position: relative;
  animation: modalbox-fadeIn 0.3s ease-in-out;
}

/* === Fade-in Animation === */
@keyframes modalbox-fadeIn {
  from {
    opacity: 0;
    transform: translateY(-20px);
  }
  to {
    opacity: 1;
    transform: translateY(0);
  }
}

/* === Action Buttons === */
.modalbox-btn {
  margin-top: 15px;
  padding: 10px 15px;
  border: none;
  border-radius: 6px;
  font-size: 14px;
  cursor: pointer;
  transition: background 0.3s ease, transform 0.2s ease;
}

.modalbox-btn:not(:last-child) {
  margin-right: 10px;
}

/* Include Button (Soft Green) */
.modalbox-btn.include {
  background-color: #81c784;
  color: white;
}

.modalbox-btn.include:hover {
  background-color: #66bb6a;
}

/* Exclude Button (Soft Red) */
.modalbox-btn.exclude {
  background-color: #ef9a9a;
  color: white;
}

.modalbox-btn.exclude:hover {
  background-color: #e57373;
}

/* === Close Button === */
.modalbox-close {
  position: absolute;
  top: 12px;
  right: 14px;
  background: none;
  border: none;
  font-size: 24px;
  color: #4a5568;
  cursor: pointer;
  transition: color 0.2s ease, transform 0.2s ease;
  line-height: 1;
}

.modalbox-close:hover {
  color: #2d3748;
  transform: scale(1.2);
}

.modalbox-close:focus {
  outline: none;
}

/* === Responsive Adjustments === */
@media (max-width: 400px) {
  .modalbox-content {
    width: 90%;
    padding: 15px;
  }

  .modalbox-close {
    font-size: 28px;
    top: 10px;
    right: 12px;
  }
}
`, "",{"version":3,"sources":["webpack://./src/Components/SideBarSection/SideBarSection.css"],"names":[],"mappings":"AAAA;EACE,kBAAkB;EAClB,yBAAyB;EACzB,kBAAkB;EAClB,kBAAkB;EAClB,0CAA0C;EAC1C,gBAAgB;EAChB,4DAA4D;EAC5D,aAAa;EACb,sBAAsB;EACtB,YAAY;EACZ,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,SAAS;AACX;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,SAAS;AACX;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,WAAW;EACX,yBAAyB;EACzB,qBAAqB;EACrB,kBAAkB;EAClB,6BAA6B;EAC7B,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,SAAS;AACX;;AAEA,mCAAmC;AACnC;EACE,kBAAkB;EAClB,YAAY;EACZ,kBAAkB;EAClB,eAAe;EACf,eAAe;EACf,sCAAsC;EACtC,WAAW;EACX,gBAAgB;EAChB,cAAc;AAChB;;AAEA;EACE,yBAAyB,EAAE,eAAe;EAC1C,WAAW;EACX,YAAY;AACd;;AAEA;EACE,yBAAyB,EAAE,eAAe;AAC5C;;AAEA;EACE,yBAAyB,EAAE,aAAa;EACxC,WAAW;EACX,YAAY;AACd;;AAEA;EACE,yBAAyB,EAAE,eAAe;AAC5C;;;;AAIA;EACE,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,yBAAyB;EACzB,kBAAkB;EAClB,WAAW;EACX,YAAY;EACZ,iDAAiD;EACjD,kBAAkB;EAClB,eAAe;AACjB;;AAEA;EACE,yBAAyB;EACzB,qBAAqB;AACvB;;AAEA;EACE,eAAe;EACf,cAAc;EACd,sBAAsB;AACxB;;;AAGA;EACE,cAAc;AAChB;;AAEA,kBAAkB;AAClB;EACE,2BAA2B;EAC3B,kBAAkB;EAClB,aAAa;EACb,sBAAsB;EACtB,WAAW;EACX,eAAe;EACf,gBAAgB;EAChB,kBAAkB;EAClB,mBAAmB;EACnB,UAAU;EACV,2BAA2B;EAC3B,oBAAoB;EACpB,wCAAwC;AAC1C;;AAEA;EACE,UAAU;EACV,wBAAwB;AAC1B;;AAEA;EACE,aAAa;;EAEb,SAAS,EAAE,uDAAuD;EAClE,eAAe;AACjB;;AAEA,0BAA0B;AAC1B;EACE,eAAe;EACf,MAAM;EACN,OAAO;EACP,WAAW;EACX,YAAY;EACZ,8BAA8B;EAC9B,aAAa;EACb,uBAAuB;EACvB,mBAAmB;EACnB,aAAa;AACf;;AAEA,0BAA0B;AAC1B;EACE,mBAAmB;EACnB,aAAa;EACb,mBAAmB;EACnB,2CAA2C;EAC3C,YAAY;EACZ,cAAc;EACd,kBAAkB;EAClB,kBAAkB;EAClB,2CAA2C;AAC7C;;AAEA,8BAA8B;AAC9B;EACE;IACE,UAAU;IACV,4BAA4B;EAC9B;EACA;IACE,UAAU;IACV,wBAAwB;EAC1B;AACF;;AAEA,2BAA2B;AAC3B;EACE,gBAAgB;EAChB,kBAAkB;EAClB,YAAY;EACZ,kBAAkB;EAClB,eAAe;EACf,eAAe;EACf,qDAAqD;AACvD;;AAEA;EACE,kBAAkB;AACpB;;AAEA,gCAAgC;AAChC;EACE,yBAAyB;EACzB,YAAY;AACd;;AAEA;EACE,yBAAyB;AAC3B;;AAEA,8BAA8B;AAC9B;EACE,yBAAyB;EACzB,YAAY;AACd;;AAEA;EACE,yBAAyB;AAC3B;;AAEA,yBAAyB;AACzB;EACE,kBAAkB;EAClB,SAAS;EACT,WAAW;EACX,gBAAgB;EAChB,YAAY;EACZ,eAAe;EACf,cAAc;EACd,eAAe;EACf,gDAAgD;EAChD,cAAc;AAChB;;AAEA;EACE,cAAc;EACd,qBAAqB;AACvB;;AAEA;EACE,aAAa;AACf;;AAEA,mCAAmC;AACnC;EACE;IACE,UAAU;IACV,aAAa;EACf;;EAEA;IACE,eAAe;IACf,SAAS;IACT,WAAW;EACb;AACF","sourcesContent":[".SideBar {\n  grid-area: sidebar;\n  background-color: #ffffff;\n  padding: 20px 16px;\n  border-radius: 8px;\n  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.05);\n  max-width: 280px;\n  font-family: 'Segoe UI', Tahoma, Geneva, Verdana, sans-serif;\n  display: flex;\n  flex-direction: column;\n  height: 100%;\n  overflow-y: auto;\n}\n\n.sidebar-inner {\n  display: flex;\n  flex-direction: column;\n  gap: 24px;\n}\n\n.sidebar-section {\n  display: flex;\n  flex-direction: column;\n  gap: 12px;\n}\n\n.sidebar-title {\n  font-size: 14px;\n  font-weight: 600;\n  color: #333;\n  text-transform: uppercase;\n  letter-spacing: 0.5px;\n  margin-bottom: 6px;\n  border-bottom: 1px solid #eee;\n  padding-bottom: 4px;\n}\n\n.sidebar-actions {\n  display: flex;\n  flex-direction: column;\n  gap: 10px;\n}\n\n/* Optional: shared button styles */\n.btnf {\n  padding: 10px 16px;\n  border: none;\n  border-radius: 6px;\n  font-size: 14px;\n  cursor: pointer;\n  transition: background-color 0.3s ease;\n  width: 100%;\n  max-width: 220px;\n  margin: 0 auto;\n}\n\n.btnf.include {\n  background-color: #81c784; /* Soft green */\n  color: #fff;\n  border: none;\n}\n\n.btnf.include:hover {\n  background-color: #66bb6a; /* Calm hover */\n}\n\n.btnf.exclude {\n  background-color: #ef9a9a; /* Soft red */\n  color: #fff;\n  border: none;\n}\n\n.btnf.exclude:hover {\n  background-color: #e57373; /* Calm hover */\n}\n\n\n\n.icon-wrapper {\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  background-color: #f0f2f5;\n  border-radius: 50%;\n  width: 50px;\n  height: 50px;\n  transition: background-color 0.3s, transform 0.3s;\n  position: relative;\n  cursor: pointer;\n}\n\n.icon-wrapper:hover {\n  background-color: #e0e7ff;\n  transform: scale(1.1);\n}\n\n.Icon-clear {\n  font-size: 30px;\n  color: #007BFF;\n  transition: color 0.2s;\n}\n\n\n.icon-wrapper:hover .con-clear {\n  color: #0056b3;\n}\n\n/* Tooltip style */\n.icon-wrapper::after {\n  content: attr(data-tooltip);\n  position: absolute;\n  bottom: -30px;\n  background-color: #333;\n  color: #fff;\n  font-size: 12px;\n  padding: 4px 8px;\n  border-radius: 4px;\n  white-space: nowrap;\n  opacity: 0;\n  transform: translateY(10px);\n  pointer-events: none;\n  transition: opacity 0.3s, transform 0.3s;\n}\n\n.icon-wrapper:hover::after {\n  opacity: 1;\n  transform: translateY(0);\n}\n\n.p-style {\n  display: flex;\n  \n  margin: 0; /* Adjust or remove this as necessary for your design */\n  margin-top : 2%;\n}\n\n/* === Modal Overlay === */\n.modalbox-overlay {\n  position: fixed;\n  top: 0;\n  left: 0;\n  width: 100%;\n  height: 100%;\n  background: rgba(0, 0, 0, 0.5); \n  display: flex;\n  justify-content: center;\n  align-items: center;\n  z-index: 1000;\n}\n\n/* === Modal Content === */\n.modalbox-content {\n  background: #ffffff;\n  padding: 20px;\n  border-radius: 12px;\n  box-shadow: 0px 4px 15px rgba(0, 0, 0, 0.3);\n  width: 350px;\n  max-width: 90%;\n  text-align: center;\n  position: relative;\n  animation: modalbox-fadeIn 0.3s ease-in-out;\n}\n\n/* === Fade-in Animation === */\n@keyframes modalbox-fadeIn {\n  from {\n    opacity: 0;\n    transform: translateY(-20px);\n  }\n  to {\n    opacity: 1;\n    transform: translateY(0);\n  }\n}\n\n/* === Action Buttons === */\n.modalbox-btn {\n  margin-top: 15px;\n  padding: 10px 15px;\n  border: none;\n  border-radius: 6px;\n  font-size: 14px;\n  cursor: pointer;\n  transition: background 0.3s ease, transform 0.2s ease;\n}\n\n.modalbox-btn:not(:last-child) {\n  margin-right: 10px;\n}\n\n/* Include Button (Soft Green) */\n.modalbox-btn.include {\n  background-color: #81c784;\n  color: white;\n}\n\n.modalbox-btn.include:hover {\n  background-color: #66bb6a;\n}\n\n/* Exclude Button (Soft Red) */\n.modalbox-btn.exclude {\n  background-color: #ef9a9a;\n  color: white;\n}\n\n.modalbox-btn.exclude:hover {\n  background-color: #e57373;\n}\n\n/* === Close Button === */\n.modalbox-close {\n  position: absolute;\n  top: 12px;\n  right: 14px;\n  background: none;\n  border: none;\n  font-size: 24px;\n  color: #4a5568;\n  cursor: pointer;\n  transition: color 0.2s ease, transform 0.2s ease;\n  line-height: 1;\n}\n\n.modalbox-close:hover {\n  color: #2d3748;\n  transform: scale(1.2);\n}\n\n.modalbox-close:focus {\n  outline: none;\n}\n\n/* === Responsive Adjustments === */\n@media (max-width: 400px) {\n  .modalbox-content {\n    width: 90%;\n    padding: 15px;\n  }\n\n  .modalbox-close {\n    font-size: 28px;\n    top: 10px;\n    right: 12px;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
